// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c1fea600","488":"fbdb4441"}[chunkId] + ".chunk.js";
};